import { render } from "./ShowAlert.vue?vue&type=template&id=2f1d2dd3"
import script from "./ShowAlert.vue?vue&type=script&lang=js"
export * from "./ShowAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__